import { type BillingPeriod, type PlanId, planById } from './catalogue'

/**
 * Deep links into the checkout: `/checkout?plan=online-only&billing=monthly`.
 *
 * The marketing site's pricing buttons carry the plan in the URL so step 1 is
 * answered on arrival. Values are validated against the catalogue — a stale
 * or mistyped link degrades to the normal flow rather than a broken page —
 * and `billing` is optional, so a link can name a plan without deciding the
 * period for the visitor.
 */

export interface PlanLink {
  planId: PlanId
  billing?: BillingPeriod
}

export function readPlanLink(search: string): PlanLink | null {
  const params = new URLSearchParams(search)
  const plan = planById(params.get('plan') ?? '')
  if (!plan) return null

  const billing = params.get('billing')
  return billing === 'annual' || billing === 'monthly'
    ? { planId: plan.id, billing }
    : { planId: plan.id }
}
